// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NnEn","rootMobile":"styles_rootMobile__2SSXM"};